var _defs, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 592.3 73.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        fill: #808285;\n        font-family: AdobeClean-Bold, 'Adobe Clean';\n        font-size: 68px;\n        font-weight: 700;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        letter-spacing: .01em;\n      }\n\n      .cls-9 {\n        letter-spacing: .01em;\n      }\n\n      .cls-10 {\n        letter-spacing: 0em;\n      }\n\n      .cls-11 {\n        letter-spacing: 0em;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        letter-spacing: .01em;\n      }\n\n      .cls-14 {\n        letter-spacing: .01em;\n      }\n\n      .cls-15 {\n        letter-spacing: 0em;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 56.64) scale(.69 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 55.96,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 90.58,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 127.3,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 144.16,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 173.74,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 190.4,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 227.87,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 262.88,
    y: 0
  }, "s &amp; "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 368.49,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    x: 413.57,
    y: 0
  }, "ea"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 481.43,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 500.13,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 521.96,
    y: 0
  }, "h "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 575.06,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 611.85,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 640,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 667.61,
    y: 0
  }, "en"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 739.21,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 761.04,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 778.18,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 811.9,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 830.67,
    y: 0
  }, "s"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.274f0dcd7593a992ba81fc8319a77eff.svg";
export { ForwardRef as ReactComponent };